// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'TTCommons', 'TTCommons Fallback'"},"className":"__className_72a14e","variable":"__variable_72a14e"};